import { getGradeName } from 'modules/ElementaryCheckins/utils';

const getGradeFilter = response => {
  const formattedData = response.data
    .sort((a, b) => Number(a) - Number(b))
    .map(entry => ({
      id: entry,
      name: getGradeName({ grade: entry }),
    }));

  return {
    key: 'grades',
    source: 'grades',
    filterName: 'Grades',
    searchable: false,
    defaultSelection: formattedData,
    options: formattedData,
    selector: 'id',
    label: 'name',
  };
};

export default getGradeFilter;
